import angular from 'angular';
import { INVALID_VALUE } from "@/utils/attributes";

angular.module('vrm.components')
    .filter('vrmNotApplicable', vrmNotApplicable)
    .filter('vrmFallback', vrmFallback);

function isEmpty(value) {
    return (value === '' || value === null || value === undefined || value === false);
}

function vrmNotApplicable() {
    return value => isEmpty(value) ? INVALID_VALUE : value;
}

function vrmFallback() {
    return (value, fallback) => isEmpty(value) ? fallback : value;
}
